// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ninetales: PokeData = {
  "id": 38,
  "name": "ninetales",
  "height": 11,
  "weight": 199,
  "base_experience": 177,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "roar",
    "disable",
    "ember",
    "flamethrower",
    "fire-spin",
    "hypnosis",
    "quick-attack",
    "confuse-ray",
    "fire-blast",
    "flame-wheel",
    "spite",
    "safeguard",
    "will-o-wisp",
    "imprison",
    "grudge",
    "extrasensory",
    "nasty-plot",
    "hex",
    "incinerate",
    "inferno"
  ],
  "moves": [
    "tackle",
    "ember",
    "flamethrower",
    "fire-spin",
    "quick-attack",
    "confuse-ray",
    "flare-blitz",
    "eruption",
    "fire-ball",
    "blaze-kick",
    "fire-punch",
    "morning-sun",
    "fire-fang"
  ],
  "evolution_chain": {
    "id": 15,
    "item": null,
    "species": [
      {
        "name": "vulpix",
        "order": 39,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ninetales",
        "order": 40,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 37,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 153,
    "ability_power": 124
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
